// extracted by mini-css-extract-plugin
module.exports = {"plain-text":"_18jMqNdtPl","plainText":"_18jMqNdtPl"};
    if(module.hot) {
      // 1614934744114
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  